<template>
  <div id="app">
    <transition-group name="fade">

      <div v-show="startedQuiz === false" key="intro" class="intro">
        <div class="bg"></div>
        <div class="intro-inner">
          <h1>Measuring Volume Quiz</h1>
          <p>Select the most accurate volume based on the graduated cylinder shown. Then, consider the markings on the cylinder to determine the uncertainty value for the measurement.</p>
          <button class="btn" v-on:click="startedQuiz = true">Begin Quiz</button>
        </div>
      </div>

      <quiz v-bind:questions="questions" v-on:restartQuiz="startedQuiz = false" v-show="startedQuiz === true" key="quizComponent"></quiz>

    </transition-group>
  </div>
</template>

<script>
import Quiz from './components/Quiz'

export default {
  name: 'app',
  components: {
    Quiz
  },
  data: function () {
    return {
      startedQuiz: false,
      questions: [
        {
          name: '10 mL Cylinder',
          total: 10,
          uncertainty: 0.05,
          volume: '9.23',
          options: [ '9.23', '9.2', '9.245' ],
          zoom: 'cylinder-9-23-zoom.svg',
          cylinder: 'cylinder-9-23.svg'
        },
        {
          name: '10 mL Cylinder',
          total: 10,
          uncertainty: 0.05,
          volume: '0.75',
          options: [ '0.7', '0.750', '0.75' ],
          zoom: 'cylinder-075-zoom.svg',
          cylinder: 'cylinder-075.svg'
        },
        {
          name: '10 mL Cylinder',
          total: 10,
          uncertainty: 0.05,
          volume: '3.67',
          options: [ '3.6', '3.701', '3.67' ],
          zoom: 'cylinder-3-67-zoom.svg',
          cylinder: 'cylinder-3-67.svg'
        },
        {
          name: '10 mL Cylinder',
          total: 10,
          uncertainty: 0.05,
          volume: '5.16',
          options: [ '5.2', '5.16', '5.159' ],
          zoom: 'cylinder-5-16-zoom.svg',
          cylinder: 'cylinder-5-16.svg'
        },
        {
          name: '10 mL Cylinder',
          total: 10,
          uncertainty: 0.05,
          volume: '7.48',
          options: [ '7.481', '7.4', '7.48' ],
          zoom: 'cylinder-7-48-zoom.svg',
          cylinder: 'cylinder-7-48.svg'
        },
        {
          name: '100 mL Cylinder',
          total: 100,
          uncertainty: 0.5,
          volume: '42.7',
          options: [ '42', '42.7', '42.75' ],
          zoom: 'cylinder-42-7-zoom.svg',
          cylinder: 'cylinder-42-7.svg'
        },
        {
          name: '100 mL Cylinder',
          total: 100,
          uncertainty: 0.5,
          volume: '6.2',
          options: [ '6.25', '6.2', '6.208' ],
          zoom: 'cylinder-6-2-zoom.svg',
          cylinder: 'cylinder-6-2.svg'
        },
        {
          name: '100 mL Cylinder',
          total: 100,
          uncertainty: 0.5,
          volume: '94.7',
          options: [ '94.7', '94', '94.75' ],
          zoom: 'cylinder-94-7-zoom.svg',
          cylinder: 'cylinder-94-7.svg'
        },
        {
          name: '100 mL Cylinder',
          total: 100,
          uncertainty: 0.5,
          volume: '19.5',
          options: [ '19', '19.5', '19.55' ],
          zoom: 'cylinder-19-5-zoom.svg',
          cylinder: 'cylinder-19-5.svg'
        },
        {
          name: '100 mL Cylinder',
          total: 100,
          uncertainty: 0.5,
          volume: '68.0',
          options: [ '68.00', '68.0', '68' ],
          zoom: 'cylinder-68-zoom.svg',
          cylinder: 'cylinder-68.svg'
        },
        {
          name: '1000 mL Cylinder',
          total: 1000,
          uncertainty: 5,
          volume: '748',
          options: [ '748.0', '748', '748.25' ],
          zoom: 'cylinder-748-zoom.svg',
          cylinder: 'cylinder-748.svg'
        },
        {
          name: '1000 mL Cylinder',
          total: 1000,
          uncertainty: 5,
          volume: '225',
          options: [ '225', '225.50', '225.5' ],
          zoom: 'cylinder-225-zoom.svg',
          cylinder: 'cylinder-225.svg'
        },
        {
          name: '1000 mL Cylinder',
          total: 1000,
          uncertainty: 5,
          volume: '883',
          options: [ '883.25', '883.2', '883' ],
          zoom: 'cylinder-883-zoom.svg',
          cylinder: 'cylinder-883.svg'
        },
        {
          name: '1000 mL Cylinder',
          total: 1000,
          uncertainty: 5,
          volume: '50.',
          options: [ '50.0', '50.', '50.00' ],
          zoom: 'cylinder-50-zoom.svg',
          cylinder: 'cylinder-50.svg'
        },
        {
          name: '1000 mL Cylinder',
          total: 1000,
          uncertainty: 5,
          volume: '451',
          options: [ '451', '451.5', '451.75' ],
          zoom: 'cylinder-451-zoom.svg',
          cylinder: 'cylinder-451.svg'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
@import "assets/styles.scss";
.intro {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  h1 {
    font: bold 32px $font-family;
    color: $dk_grey;
    margin: 0 0 16px;
    letter-spacing: 1.5px;
  }
  p br { display: none; }
  .intro-inner { position: relative; }
  .bg {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background: #fff url(../static/cylinder.svg) no-repeat center center;
    opacity: 0.2;
  }
}
@media screen and (min-width: 600px) {
  .intro p br { display: block; }
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}
.fade-enter-active {
  transition-delay: 0.35s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
.btn {
  border: none;
  background: $blue;
  color: #fff;
  padding: 10px 40px;
  text-transform: uppercase;
  font: bold 16px $font-family;
  letter-spacing: 2px;
  cursor: pointer;
}
p { 
  color: $dk_grey;
  font-size: 20px;
  letter-spacing: 1.5px;
  margin: 0 0 20px;
}
</style>


// WEBPACK FOOTER //
// App.vue?92595e70